import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const SidebarMenuItem = ({ className, ...props }: ComponentProps<"li">) => (
  <li data-slot="sidebar-menu-item" className={cn("relative", className)} {...props} />
);
